import _styled from "styled-components";
var _CrehanaLogo;
import { css } from "styled-components";
import { useTranslation } from "@crehana/i18n";
import { CrehanaLogo } from "@crehana/icons/logos";
import { Col } from "@crehana/ui";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Copyright = function Copyright(_ref) {
  var isDark = _ref.isDark,
    className = _ref.className;
  var _useTranslation = useTranslation('main-footer'),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Col, {
    md: 8,
    lg: 6,
    nowrap: true,
    className: "".concat(className, " text-center md:text-left mt-24 sm:mt-48 lg:mt-0"),
    children: [/*#__PURE__*/_jsx("span", {
      className: "block sm:inline-block mb-20 sm:mb-0 ".concat(isDark ? 'text-white' : 'text-primary-main'),
      children: _CrehanaLogo || (_CrehanaLogo = /*#__PURE__*/_jsx(CrehanaLogo, {
        size: 24,
        ignoreColor: true,
        className: "fill-current sm:mr-32"
      }))
    }), /*#__PURE__*/_jsxs(_StyledSpan, {
      className: "font-legals ".concat(isDark ? 'text-base-lighter' : 'text-gray-dark'),
      children: ["Copyright \xA9 Crehana ".concat(new Date().getFullYear(), " - \n"), t('RIGHTS_RESERVED')]
    })]
  });
};
export default Copyright;
var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  componentId: "sc-5r9t3s-0"
})(["\n          ", " {\n            white-space: pre-line;\n          }\n        "], function (props) {
  return props.theme.breakpoints.down('sm');
});